const TitleSection = ({ title, subtitle }) => (
  <div className="text-center flex flex-col justify-center">
    <h2 className="text-[20px] leading-[32px] font-bold text-[#111827] mb-[4px]">
      {title}
    </h2>
    <p className="text-[16px] leading-[24px] text-[#636369]">{subtitle}</p>
  </div>
);

export default TitleSection;
